import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppointmentService } from '../appointment/appointment.service';
import { AppointmentTime } from '../appointment/appointmentTime';
import { StudioDate } from "../shared/studio-date";
import { AppointmentDate } from "../shared/appointment-date";
import { AppointmentMoment } from "../shared/appointment-moment";
import { AuthService } from '../auth.service';
import { LocalizedHash, MapToLocalizedHash } from '../localization/localization';
import { LocalizedstringsService } from '../localization/localizedstrings.service';
import { MasterDataService } from '../masterdata/masterdata-service.service';
import { MessageService } from '../message.service';
import { AddAppointmentRequest } from './add-appointment.request';

@Component({
  selector: 'app-add-appointment',
  templateUrl: './add-appointment.component.html',
  styleUrls: ['./add-appointment.component.css']
})
export class AddAppointmentComponent implements OnInit {

  appointmentForm;
  startDate: Date;
  localized: LocalizedHash = {};
  timeList = new Array<AppointmentTime>();
  selectedHairdresser="";
  selectedServiceName="";
  availableDates = new Array<AppointmentDate>();
  selectedTime : AppointmentTime;
  selectedDate = new StudioDate();
  selectedServiceTranslatedName ="";
  waiting = false;
  showConfirmation = false;
  longHair = false;
  highLight = false;

  constructor( public masterData: MasterDataService,
    private authService: AuthService,
    private appointmentService: AppointmentService,
    private formBuilder: UntypedFormBuilder,
    private localizedstringService: LocalizedstringsService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private router: Router) {
      this.localizedstringService.getAllAsync()
      .subscribe(result => this.localized = MapToLocalizedHash(result)
      , error=> this.messageService.handleError(error));
    }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(
      isAuthenticated => { if (!isAuthenticated){
        this.router.navigate(["/register"]);
      }})

      this.appointmentForm = this.formBuilder.group({
        formArray : this.formBuilder.array([
          this.formBuilder.group({
              hairdresserCtrl : ['', Validators.required]
          }),
          this.formBuilder.group({
            serviceCtrl : ['', Validators.required],
            longHairCtrl :[''],
            highlightCtrl :['']
          }),
          this.formBuilder.group({
              dateCtrl : ['', Validators.required]
          }),
          this.formBuilder.group({
              timeCtrl : ['', Validators.required]
          }),
          this.formBuilder.group({
              nameCtrl : ['', Validators.required],
          })
        ])
      });
  }

  /** Returns a FormArray with the name 'formArray'. */
  get formArray(): AbstractControl | null { return this.appointmentForm.get('formArray'); }

  calendarFilter = (d: Date): boolean => {
    const date = AppointmentDate.MapFromDate(d);
    return this.availableDates.find(ad => ad.day == date.day && ad.month == date.month && ad.year == date.year) != undefined;
  }

  onSubmit(formData) {
    // Process checkout data here
    let hairdresser: string = formData.formArray[0].hairdresserCtrl;
    let service = formData.formArray[1].serviceCtrl;
    let longHair : boolean = formData.formArray[1].longHairCtrl;
    let highlight : boolean = formData.formArray[1].highlightCtrl;
    let date : Date = formData.formArray[2].dateCtrl;
    let time : AppointmentTime = formData.formArray[3].timeCtrl;
    let moment = new AppointmentMoment(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      time.hour,
      time.minutes
      );
    let name = formData.formArray[4].nameCtrl;

    const appointment = new AddAppointmentRequest(
        moment,
        hairdresser,
        longHair == true,
        highlight == true,
        service.name,
        this.authService.getCustomerGuid(),
        name
        );
      this.waiting = true;

      this.appointmentService.addAppointment(appointment)
        .subscribe(result => {

          this.waiting = false;
          window.location.href="./confirmation?customerGuid="+ this.authService.getCustomerGuid() +"&appointmentId=" + result.appointmentId;
        }, error => {
          this.showError(error);
          this.waiting = false;
        });
  }

  selectedDateChanged(event){
    this.selectedTime = undefined;
    this.selectedDate = new StudioDate(event.value);
    var appointmentDate = AppointmentDate.MapFromDate(this.selectedDate);
    this.appointmentService.getAvailableAppointmentTimes(appointmentDate, this.selectedServiceName, this.selectedHairdresser, this.longHair || this.highLight)
    .subscribe(times => this.timeList = times,
      error=> this.messageService.handleError(error));
  }

  resetSelection(event){
    this.selectedTime = undefined;
    this.selectedDate =  new StudioDate();
    this.loadAvailableDates();
  }

  loadAvailableDates(){
    this.timeList = new Array<AppointmentTime>();
    if (this.selectedServiceName && this.selectedHairdresser){
      this.waiting = true;
      this.appointmentService.getAvailableDates(this.selectedHairdresser, this.selectedServiceName, this.longHair || this.highLight)
          .subscribe(ad => {
            this.availableDates = ad;
            this.waiting = false;
          }, error=> this.messageService.handleError(error));
    }
  }

  showError(error: any) {
    if (error.error) {
      this.messageService.showErrorMessage(error.error);
    }
    else if (error.message) {
      this.messageService.showErrorMessage(error.message);
    }
  }
}
